// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__qkDNB","headerLogo":"Logo_headerLogo__ZxGvS"};